import { render } from "./ChangelogEntry.vue?vue&type=template&id=0b45bf7c&scoped=true"
import script from "./ChangelogEntry.vue?vue&type=script&lang=js"
export * from "./ChangelogEntry.vue?vue&type=script&lang=js"

import "./ChangelogEntry.vue?vue&type=style&index=0&id=0b45bf7c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b45bf7c"]])

export default __exports__